module.exports = __webpack_public_path__ + "img/위영양제.dab35957.png";